module.exports = {
	"ro": {
		"translation": {
			"moreInformation": "informații suplimentare",
			"close": "Închidere",
			"uploader": {
				"overlay": {
					"title": "Glisare și fixare ",
					"subtitle": "Fișierele dvs. sunt aici"
				},
				"form": {
					"dragAndDrop": "Glisare și fixare",
					"or": "sau",
					"chooseFiles": "Selectare fișiere",
					"from": "Din computer"
				},
				"errors": {
					"file_size": "depășește dimensiunea maximă {{size}} a fișierului.",
					"file_type": "{{type}} este un tip de fișier incorect."
				},
				"status": {
					"idle": "inactiv",
					"processing": "procesare",
					"uploading": "se încarcă",
					"success": "succes",
					"cancel": "anulare",
					"error": "eroare",
					"none": ""
				}
			},
			"actions": {
				"delete": "Ștergere",
				"apply": "Aplică",
				"cancel": "Anulare"
			},
			"dateInput": {
				"choose": "Selectare dată",
				"clear": "Ștergere dată"
			},
			"daterange": {
				"last_7_days": "Ultimele 7 zile",
				"last_30_days": "Ultimele 30 zile",
				"this_month": "Luna curentă",
				"last_month": "Ultima lună",
				"start_date": "Data de început",
				"end_date": "Data de sfârșit",
				"not_set": "Nesetat"
			},
			"comment": {
				"delete": "Ștergere comentariu"
			},
			"pagination": {
				"intro": "Paginare, momentan pe pagina {{currentPage}}",
				"page": "Pagină {{pageNumber}}",
				"ellipsis": "Mai multe pagini",
				"prev": "Pagina anterioară",
				"next": "Pagina următoare"
			},
			"formElement": {
				"optional": "(opțional)",
				"required": "(obligatoriu)"
			},
			"prevNextArrowButton": {
				"arrowup": "sus",
				"arrowdown": "jos",
				"escape": "renunțare"
			},
			"externalLink": {
				"view": "vizualizare"
			},
			"collapsible": {
				"ariaText": "secțiune ce se poate restrânge"
			}
		}
	}
};